import { Button } from "./button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";

export function BackButton() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <Button
      variant="ghost"
      size={isMobile ? "icon" : "default"}
      onClick={() => navigate(-1)}
    >
      <ArrowLeft className="size-4" />
      <span className={isMobile ? "hidden" : "inline"}>Back</span>
    </Button>
  );
}